import * as React from "react";
export function SvgSchemaViewerNumberDiscrete(
  props: React.SVGProps<SVGSVGElement>
): JSX.Element {
  return (
    <svg width={24} height={17} {...props}>
      <path
        d="M16.5 9H14V7h2.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H14V3.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5V6h-2V3.5c0-.3-.2-.5-.5-.5s-.5.2-.5.5V6H7.5c-.3 0-.5.2-.5.5s.2.5.5.5H10v2H7.5c-.3 0-.5.2-.5.5s.2.5.5.5H10v2.5c0 .3.2.5.5.5s.5-.2.5-.5V10h2v2.5c0 .3.2.5.5.5s.5-.2.5-.5V10h2.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zM11 9V7h2v2h-2z"
        fill="#367e9c"
      />
    </svg>
  );
}
